import ApiManagerBase from "./ApiManagerBase";
import ApiManagerOffline from "./ApiManagerOffline";
import { isFeatureOn, Feature } from "data/constants";

const ApiManager = isFeatureOn(Feature.offline)
    ? new ApiManagerOffline()
    : new ApiManagerBase();
export default ApiManager;
